"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const plugins_1 = require("./plugins");
class LegendHandler extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        // our controls
        this.controls = {
            active: { type: 'check', value: false },
            legend: { type: 'legend', size: 0, items: [], min: 0, max: 0, mode: 'elevation', threshold: 0, thresholdPercent: true, showMinMaxValues: true, showRangeLabels: true, noshow: true },
            showMinMaxValues: { type: 'check', value: true },
            showRangeHeightValues: { type: 'check', value: true },
            showRangeLabels: { type: 'check', value: true },
            showThreshold: { type: 'check', value: true },
        };
        this.options = ['showMinMaxValues', 'showRangeHeightValues', 'showRangeLabels', 'showThreshold'];
        this.legendPanel = null;
        // our color / range configuration
        this.config = null;
        // full color scale
        this.colors = null;
        this.colorScheme = null;
        this.palette = null;
        // incoming values from those colors
        this.values = null;
        this.legendSize = 200;
        this.maxLegends = 20;
    }
    valuesInjected(config = null) {
        this.config = config;
        this.config.opacity = 1;
        if (this.config.type) {
            this.config.colorName = this.config.type;
            this.colorScheme = this.services.colorManager.getColors(this.config.type, { items: this.legendSize, order: this.config.order });
            this.colors = this.services.colorManager.renderColors(this.colorScheme, 'css-vertical', this.config);
            this.palette = this.services.colorManager.getPalette(this.config.type);
            // this.values = this.services.colorManager.getColors ( this.config.type, { items: this.palette.colors.length, order:this.config.order, returnStructuredInfo:true } );
        }
        this.controls.legend.mode = this.config.shader;
        // this.values = this.services.mapService.getColorScheme ( this.config.type, this.config.thresholdtype ? 100 : this.config.threshold, 100, true );
        if (!config.max || !config.attributeRenderMode) {
            return;
        }
        this.controls.legend.items = [];
        if (config.attributeRenderMode == 'colormap') {
            this.turnOff(['showMinMaxValues', 'showRangeHeightValues', 'showThreshold']);
            // console.log('@@LEGEND valuesInjected() COLORMAP', config.attributeRenderMode, config, this.palette );
            if (!config.attributeMap) {
                return;
            }
            let keys = Object.keys(config.attributeMap);
            // if ( keys.length && keys.length < 20 ) {
            // }
            this.controls.legend.size = keys.length;
            let count = 0;
            keys.forEach(key => {
                let c = config.attributeMap[key];
                if (count < this.maxLegends) {
                    this.controls.legend.items.push({
                        label: key, size: 30, color: c.color
                    });
                }
                count++;
            });
        }
        else {
            this.turnOn(['showMinMaxValues', 'showRangeHeightValues', 'showThreshold']);
            // console.log('@@LEGEND valuesInjected() VALUECHECK', config.attributeRenderMode, config, this.palette );
            let min = this.config.min;
            let max = this.config.max;
            this.controls.legend.size = this.palette.__colors_length;
            this.controls.legend.min = min;
            this.controls.legend.max = max;
            this.controls.legend.threshold = config.threshold;
            this.controls.legend.thresholdPercent = !config.thresholdAbsolute;
            // const isStriped = ( config.type == 'stripe' || config.type == 'split' ) ? true : false;
            // default is percent
            let range = { sourceMin: 0, sourceMax: 100, targetMin: min, targetMax: max };
            if (this.config.shader == 'slope') {
                // console.log('####### slope', this.config.shader );
                this.turnOff(['showMinMaxValues', 'showThreshold']);
                let sofar = 0;
                ['0', '12', '24', '36', '48', '60', '72', '84', '90'].forEach(dir => {
                    this.controls.legend.items.push({
                        label: dir, min: 1, max: 3, size: 11.11, height: Math.round(90 - (11.11 * sofar))
                    });
                    sofar++;
                });
                this.controls.legend.items.reverse();
            }
            else if (this.config.shader == 'aspect') {
                // console.log('####### aspect', this.config.shader );
                this.turnOff(['showMinMaxValues', 'showThreshold']);
                let sofar = 0;
                ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'].forEach(dir => {
                    this.controls.legend.items.push({
                        label: this.meta.translator + '.DIRECTION_' + dir, min: 1, max: 3, size: 12.5, height: 12.5 * sofar
                    });
                    sofar++;
                });
            }
            else {
                // console.log('####### elevation', this.config.shader );
                let sofar = 0;
                this.palette.colors.forEach(c => {
                    let heightPercentage = c[3];
                    this.controls.legend.items.push({
                        label: c[0], min: c[1], max: c[2], size: heightPercentage, height: this.services.colorManager.getScaledValue(sofar + (heightPercentage / 2), range)
                    });
                    sofar = sofar + c[3];
                });
                this.controls.legend.items.reverse();
            }
        }
        // console.log('########### LEGEND ', this.config, this.palette, this.controls.legend.items, this.services.mapService['currentProject'] );
        this.refresh();
    }
    linearScale() {
        return this.colors;
    }
    linearScaleY(value = 1, scale = 1) {
        let range = null;
        if (this.config.thresholdAbsolute) {
            range = { sourceMin: this.config.min, sourceMax: this.config.max, targetMin: 0, targetMax: this.legendSize * scale };
        }
        else {
            range = { sourceMin: 0, sourceMax: 100, targetMin: 0, targetMax: this.legendSize * scale };
        }
        return (this.legendSize * scale) - this.services.colorManager.getScaledValue(value, range);
    }
    linearScaleHeight(scale = 1, percent = 100) {
        const value = (this.legendSize / 100) * percent;
        return (value * scale) + 'px';
    }
    refresh(newvalue = null, section = null) {
        // check in with mama
        super.refresh(newvalue, section);
        if (this.controls.active.value) {
            this.turnOn(this.options);
            if (!this.legendPanel) {
                this.legendPanel = this.services.uiManager.addPanel(this.id, [], this);
            }
            if (this.legendPanel) {
                this.transferControlValues('legend', this.options);
                // console.log('@@LEGEND refresh()', this.config, this.palette );
                let obj = {
                    type: 'legend',
                    size: this.controls.legend.size,
                    items: this.controls.legend.items,
                    renderMode: this.config.attributeRenderMode,
                    mode: this.controls.legend.mode,
                    property: this.config.attribute,
                    min: this.controls.legend.min,
                    max: this.controls.legend.max,
                    hasThreshold: (this.config.type == 'stripe' || this.config.type == 'split') ? true : false,
                    threshold: this.config.threshold,
                    thresholdPercent: !this.config.thresholdAbsolute
                };
                this.transferControlValuesToObject(obj, this.options);
                this.legendPanel.items = [obj];
                // console.log('!!! legendColors DRAW', this.legendPanel );
            }
            else {
                // console.log('!!! legendColors ERROR!!!');
            }
        }
        else {
            // console.log('!!! legendColors OFF' );
            this.turnOff(this.options);
            this.end();
        }
    }
    end() {
        // console.log("@@@@@@@@@@@@@@@@@@@ END");
        if (this.legendPanel) {
            this.legendPanel = this.services.uiManager.removePanel(this.id);
        }
    }
}
// required name identifier
LegendHandler.meta = {
    label: 'PLUGINS.LEGEND_HANDLER.LABEL',
    name: 'legend-handler',
    translator: 'PLUGINS.LEGEND_HANDLER',
    tooltip: 'PLUGINS.LEGEND_HANDLER.TOOLTIP',
    hideHeader: true,
    hideWrapper: true,
    category: plugins_1.FdmPlugin.category.generic,
    cardinality: plugins_1.FdmPlugin.cardinality.one
};
exports.LegendHandler = LegendHandler;
